export const COUNTRIES = [
  { code: 'eg', name: 'مصر', flag: require('../assets/images/countries/مصر.jpg') },
  { code: 'sa', name: 'السعوديه', flag: require('../assets/images/countries/السعوديه.png') },
  { code: 'ae', name: 'الإمارات', flag: require('../assets/images/countries/الإمارات.png') },
  { code: 'jo', name: 'الاردن', flag: require('../assets/images/countries/الاردن.png') },
  { code: 'dz', name: 'الجزائر', flag: require('../assets/images/countries/الجزائر.png') },
  { code: 'iq', name: 'العراق', flag: require('../assets/images/countries/العراق.jpg') },
  { code: 'ma', name: 'المغرب', flag: require('../assets/images/countries/المغرب.png') },
  { code: 'ye', name: 'اليمن', flag: require('../assets/images/countries/اليمن.png') },
  { code: 'bh', name: 'بحرين', flag: require('../assets/images/countries/بحرين.png') },
  { code: 'tn', name: 'تونس', flag: require('../assets/images/countries/تونس.png') },
  { code: 'km', name: 'جزر القمر', flag: require('../assets/images/countries/جزر القمر.png') },
  { code: 'dj', name: 'دجيبوتي', flag: require('../assets/images/countries/دجيبوتي.png') },
  { code: 'sd', name: 'سودان', flag: require('../assets/images/countries/سودان.jpg') },
  { code: 'sy', name: 'سوريا', flag: require('../assets/images/countries/سوريا.jpg') },
  { code: 'so', name: 'صومال', flag: require('../assets/images/countries/صومال.jpg') },
  { code: 'om', name: 'عمان', flag: require('../assets/images/countries/عمان.png') },
  { code: 'ps', name: 'فلسطين', flag: require('../assets/images/countries/فلسطين.jpg') },
  { code: 'qa', name: 'قطر', flag: require('../assets/images/countries/قطر.png') },
  { code: 'kw', name: 'كويت', flag: require('../assets/images/countries/كويت.png') },
  { code: 'lb', name: 'لبنان', flag: require('../assets/images/countries/لبنان.jpg') },
  { code: 'ly', name: 'ليبيا', flag: require('../assets/images/countries/ليبيا.jpg') },
  { code: 'mr', name: 'موريتانيا', flag: require('../assets/images/countries/موريتانيا.png') },
  { code: 'tr', name: 'تركيا', flag: require('../assets/images/countries/تركيا.jpeg') },
  { code: 'eu', name: 'أوروبا', flag: require('../assets/images/countries/أوروبا.jpeg') },
];

export const COUNTRY_CODES = COUNTRIES.map(c => c.code);
